module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-5_FI-338f81cd916b4ed346ae3470b8d72872.svg";